import React, { useContext, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Form from 'react-bootstrap/Form';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import toast from 'react-hot-toast';

const Profile = () => {
    // Hooks must be called first, before any other logic
    const location = useLocation();
    const navigate = useNavigate();
    const authCtx = useContext(AuthContext);

    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [showPassword3, setShowPassword3] = useState(false);

    const [showUpdateBtn, setShowUpdateBtn] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [emailVerified, setEmailVerified] = useState(false);

    // Check if this is first time password change requirement
    const needsPasswordChange = location.state?.needsPasswordChange || false;

    // Default to Password tab if coming from login with needsPasswordChange
    const [activeTab, setActiveTab] = useState(needsPasswordChange ? 'Password' : 'Profile');
    const [passwordChanged, setPasswordChanged] = useState(false);

    // OTP dialog states
    const [otpDialogOpen, setOtpDialogOpen] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '']);
    const [verifyingOtp, setVerifyingOtp] = useState(false);

    const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
    const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
    const handleClickShowPassword3 = () => setShowPassword3((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };


    const email = location.state?.email || localStorage.getItem('email');
    const username = location.state?.username || localStorage.getItem('username');
    const UserId = localStorage.getItem('id')

    // Prevent navigation away if password change is required
    React.useEffect(() => {
        if (needsPasswordChange && !passwordChanged) {
            // Disable browser back button
            window.history.pushState(null, '', window.location.href);
            const handlePopState = () => {
                window.history.pushState(null, '', window.location.href);
                toast.error('Please change your password before continuing');
            };
            window.addEventListener('popstate', handlePopState);

            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        }
    }, [needsPasswordChange, passwordChanged]);

  
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    // React Hook Form for change password
    const {
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
        reset: reset2,
    } = useForm();

    const onSubmit = async (data) => {
        try {
            const response = await postRequest('private/updateAccount', data, authCtx.token);
            if (response?.status === 200) {
               // toast.success('User updated successfully');
                setTimeout(() => {
                    navigate('/customers');
                }, 1000);
            }
        } catch (err) {
           // toast.error(err?.message || 'Update failed');
        }
    };

    const onSubmitAgain = async (data) => {
        try {
            const response = await postRequest('private/changePassword', data, authCtx.token);
            if (response?.status === 200) {
                reset2();
                setPasswordChanged(true);

                // If this was a mandatory password change, redirect to customers page
                if (needsPasswordChange) {
                    toast.success('Password changed successfully! Redirecting...');
                    setTimeout(() => {
                        navigate('/login');
                    }, 2000);
                } else {
                    // Otherwise logout as before
                    toast.success('Password updated successfully');
                    setTimeout(() => {
                        authCtx.Logout()
                    }, 2000);
                }
            }
        } catch (err) {
            // Error toast is already handled by axios interceptor, no need to show again
            console.error('Password update failed:', err);
        }
    };

    // Show update button when email changes and is valid
    const handleEmailChange = (e) => {
        setNewEmail(e.target.value);
        setShowUpdateBtn(!!e.target.value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value));
        setEmailVerified(false); // Reset verified if email changes
    };

    // OTP input change handler
    const handleOtpChange = (e, idx) => {
        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 1);
        const newOtp = [...otp];
        newOtp[idx] = value;
        setOtp(newOtp);
        // Focus next input
        if (value && idx < 3) {
            document.getElementById(`otp-input-${idx + 1}`)?.focus();
        }
    };

    // OTP verify handler
    const handleVerifyOtp = async () => {
        const enteredOtp = otp.join('');
        if (enteredOtp.length !== 4) {
            toast.error('Please enter OTP');
            return;
        }
        setVerifyingOtp(true);
       // const userId = 
        try {
            const response = await postRequest('auth/VerifyEmailOtp', { email: newEmail, otp: enteredOtp , userId : UserId }, authCtx.token);
            if (response?.status === 200 || response?.success) {
              //  toast.success('Email verified successfully!');
                setOtpDialogOpen(false);
                setOtp(['', '', '', '']);
                setEmailVerified(true); // set verified
                localStorage.removeItem('email')
                localStorage.setItem('email',newEmail)
            } else {
                //toast.error(response?.message || 'OTP verification failed');
            }
        } catch (err) {
           // toast.error(err?.message || 'OTP verification failed');
        }
        setVerifyingOtp(false);
    };

    // Verify Email API
    const handleVerifyEmail = async () => {
        try {
            const response = await postRequest('auth/VerifyEmail', { email: newEmail }, authCtx.token);
            if (response?.status === 200 || response?.success) {
                //toast.success('Please check email for otp !');
                setOtpDialogOpen(true); // Open OTP dialog
                 setOtp(['', '', '', '']);
            } else { 
               // toast.error(response?.message || 'Verification failed');
            }
        } catch (err) {
           // toast.error(err?.message || 'Verification failed');
        }
    };

    return (
        <div className='profile-view'>
            {/* Show mandatory password change message */}
            {needsPasswordChange && !passwordChanged && (
                <div style={{
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffc107',
                    borderRadius: '4px',
                    padding: '15px',
                    marginBottom: '20px',
                    color: '#856404'
                }}>
                    <strong>⚠️ Password Change Required</strong>
                    <p style={{ margin: '5px 0 0 0' }}>
                        For security reasons, you must change your password before accessing the system.
                    </p>
                </div>
            )}

            <div className='profile-tabs'>
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => {
                        // Prevent switching tabs if password change is required
                        if (needsPasswordChange && !passwordChanged && k !== 'Password') {
                            toast.error('Please change your password first');
                            return;
                        }
                        setActiveTab(k);
                    }}
                    id="profile-tabs"
                    className="mb-3"
                >
                    <Tab
                        eventKey="Profile"
                        title="Profile"
                        disabled={needsPasswordChange && !passwordChanged}
                    >
                        <h2>Profile</h2>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Box
                                    component="form"
                                    sx={{ '& > :not(style)': { my: 1, width: '100%' } }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextField
                                        id="outlined-basic"
                                        label="Username"
                                        disabled
                                        variant="outlined"
                                        value={username || ''}
                                    />
                                </Box>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Box
                                    component="form"
                                    sx={{ '& > :not(style)': { my: 1, width: '100%' } }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextField
                                        type="email"
                                        id="outlined-basic"
                                        disabled
                                        label="Email"
                                        variant="outlined"
                                        value={email || ''}
                                    />
                                </Box>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formNewEmail">
                                <Box
                                    component="form"
                                    sx={{ '& > :not(style)': { my: 1, width: '100%' } }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextField
                                        type="email"
                                        id="email"
                                        label="New email"
                                        variant="outlined"
                                        {...register('email', {
                                            required: 'New email is required',
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: 'Invalid email address',
                                            },
                                        })}
                                        error={!!errors.email}
                                        helperText={errors.email?.message}
                                        value={newEmail}
                                        onChange={handleEmailChange}
                                        disabled={emailVerified}
                                        InputProps={{
                                            endAdornment: emailVerified ? (
                                                <InputAdornment position="end">
                                                    <CheckCircleIcon color="success" />
                                                </InputAdornment>
                                            ) : null,
                                        }}
                                    />
                                    {!emailVerified && showUpdateBtn && (
                                        <Stack spacing={2} direction="row">
                                                <Button
                                            variant="contained"
                                            className='red-bg red-button text-capitalize'
                                            size="small"
                                           // sx={{ mt: 1, ml: 1 }}
                                            onClick={handleVerifyEmail}
                                            type="button"
                                        >
                                            Verify Email
                                        </Button>
                                        </Stack>
                                    
                                    )}
                                </Box>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Box
                                    component="form"
                                    sx={{ '& > :not(style)': { my: 1, width: '100%' } }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextField
                                        type="tel"
                                        id="phone-number"
                                        label="Phone number"
                                        variant="outlined"
                                        {...register('phone_number')}
                                        error={!!errors.phone_number}
                                        helperText={errors.phone_number?.message}
                                    />
                                </Box>
                            </Form.Group>

                            <Stack spacing={2} direction="row">
                                <Button variant="contained" type="submit" className='red-bg red-button text-capitalize'  sx={{
            backgroundColor: !emailVerified ? '#e0e0e0' : undefined,
            color: !emailVerified ? '#888' : undefined,
            '&.Mui-disabled': {
                backgroundColor: '#e0e0e0',
                color: '#888',
            }
        }} disabled={!emailVerified}>Save</Button>
                            </Stack>
                        </Form>
                    </Tab>

                    <Tab eventKey="Password" title="Password">
                        <h2>Change password</h2>
                        <Form onSubmit={handleSubmit2(onSubmitAgain)}>
                            <Form.Group className="mb-3" controlId="formCurrentPassword">
                                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                    <InputLabel htmlFor="current-password">Current password</InputLabel>
                                    <OutlinedInput
                                        id="oldPassword"
                                        type={showPassword1 ? 'text' : 'password'}
                                        {...register2('oldPassword', {
                                            required: 'Current password is required',
                                            minLength: {
                                                value: 6,
                                                message: 'Minimum 6 characters required',
                                            },
                                        })}
                                        error={!!errors2.oldPassword}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword1 ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword1}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label="Current password"
                                    />
                                    {errors2.oldPassword && (
                                        <span style={{ color: 'red', fontSize: 12 }}>
                                            {errors2.oldPassword.message}
                                        </span>
                                    )}
                                </FormControl>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formNewPassword">
                                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                    <InputLabel htmlFor="new-password">New password</InputLabel>
                                    <OutlinedInput
                                        id="new-password"
                                        type={showPassword2 ? 'text' : 'password'}
                                        {...register2('newPassword', {
                                            required: 'New password is required',
                                            minLength: {
                                                value: 6,
                                                message: 'Minimum 6 characters required',
                                            },
                                        })}
                                        error={!!errors2.newPassword}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword2 ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword2}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label="New password"
                                    />
                                    {errors2.newPassword && (
                                        <span style={{ color: 'red', fontSize: 12 }}>
                                            {errors2.newPassword.message}
                                        </span>
                                    )}
                                </FormControl>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formConfirmPassword">
                                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                    <InputLabel htmlFor="confirm-password">Confirm New password</InputLabel>
                                    <OutlinedInput
                                        id="confirm-password"
                                        type={showPassword3 ? 'text' : 'password'}
                                        {...register2('confirmPassword', {
                                            required: 'Confirm password is required',
                                            minLength: {
                                                value: 6,
                                                message: 'Minimum 6 characters required',
                                            },
                                            validate: (value, formValues) =>
                                                value === formValues.newPassword || 'Passwords do not match',
                                        })}
                                        error={!!errors2.confirmPassword}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword3 ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword3}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword3 ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label="Confirm New password"
                                    />
                                    {errors2.confirmPassword && (
                                        <span style={{ color: 'red', fontSize: 12 }}>
                                            {errors2.confirmPassword.message}
                                        </span>
                                    )}
                                </FormControl>
                            </Form.Group>

                            <Stack spacing={2} direction="row">
                                <Button variant="contained" type="submit" className='red-bg red-button text-capitalize'>Update Password</Button>
                            </Stack>
                        </Form>
                    </Tab>
                </Tabs>
            </div>
            {/* OTP Dialog */}
            <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
                <DialogTitle>Enter OTP</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} justifyContent="center" mt={1} mb={1}>
                        {otp.map((digit, idx) => (
                            <TextField
                                key={idx}
                                id={`otp-input-${idx}`}
                                value={digit}
                                onChange={(e) => handleOtpChange(e, idx)}
                                inputProps={{
                                    maxLength: 1,
                                    style: { textAlign: 'center', fontSize: 24, width: 40 }
                                }}
                                autoFocus={idx === 0}
                            />
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOtpDialogOpen(false)} color="inherit" disabled={verifyingOtp}>
                        Cancel
                    </Button>
                    <Button onClick={handleVerifyOtp} variant="contained"  className='red-bg red-button text-capitalize' disabled={verifyingOtp}>
                        {verifyingOtp ? 'Verifying...' : 'Verify OTP'}
                    </Button>

                    
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Profile;